import styled, { css } from 'styled-components'
import { useMaxWidthBreakpoint } from '@sevenrooms/ui-kit/hooks'
import { Flex, HStack, Box } from '@sevenrooms/ui-kit/layout'
import { SkeletonBox } from '../../SkeletonBox'

interface OtherAvailabilitySkeletonProps {
  count?: number
}

export function OtherAvailabilitySkeleton({ count = 3 }: OtherAvailabilitySkeletonProps) {
  const isMobile = useMaxWidthBreakpoint('s')

  return (
    <>
      {[...Array(count).keys()].map(val => (
        <Box key={val} data-test="other-availability-skeleton-row">
          <SkeletonBox width="100px" height="20px" mb="m" mt={isMobile ? 'none' : 'm'} />
          <StyledTimeSlotsContainer spacing="sm" overflowX="scroll" isMobile={isMobile}>
            <Flex flex="0 0 150px">
              <SkeletonBox height="59px" />
            </Flex>
            <Flex flex="0 0 150px">
              <SkeletonBox height="59px" />
            </Flex>
            <Flex flex="0 0 150px">
              <SkeletonBox height="59px" />
            </Flex>
            <Flex flex="0 0 150px">
              <SkeletonBox height="59px" />
            </Flex>
            <Flex flex="0 0 150px">
              <SkeletonBox height="59px" />
            </Flex>
          </StyledTimeSlotsContainer>
        </Box>
      ))}
    </>
  )
}

const StyledTimeSlotsContainer = styled(HStack)<{ isMobile: boolean }>`
  ${({ isMobile }) =>
    !isMobile &&
    css`
      -ms-overflow-style: none;
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
    `}
`
